export default "/images/vendor/flag-icon-css/flags/1x1/tr.svg?c3d773f3ebbea061e963baad5606508a";